import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useRef } from "react";
import { MaskedLines } from "../store/Reveal";

export const HERO_IMG = "https://static.wixstatic.com/media/d32254_59c79988ac174e13989b93113bc3f558~mv2.jpg/v1/fill/w_1200,h_1000,al_c,q_85/d32254_59c79988ac174e13989b93113bc3f558~mv2.jpg";

export const HomeHero = () => {
  const heroRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: heroRef, offset: ["start start", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);

  return (
    <section ref={heroRef} className="relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 pt-14 lg:pt-24 pb-16 lg:pb-28 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <motion.p
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.05 }}
            className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#2E8A57] mb-6"
          >
            Certificato Gluten Free — Chef Michel
          </motion.p>
          <h1 className="font-serif-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#1C1917]">
            <MaskedLines lines={["La cucina", "italiana"]} />
            <MaskedLines lines={["senza glutine."]} lineClassName="italic text-[#2E8A57]" startDelay={0.45} />
          </h1>
          <motion.p
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.8, duration: 0.7 }}
            className="mt-7 text-base md:text-lg text-[#44403C] max-w-lg leading-relaxed"
          >
            Piatti pronti genuini, 100% italiani. Pronti in soli 5 minuti, consegnati a casa tua in tutta Italia.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.95, duration: 0.7 }}
            className="mt-9 flex flex-wrap gap-4"
          >
            <Link to="/prodotti" data-testid="hero-shop-btn" className="btn-tuscan inline-flex items-center gap-2 px-8 py-4 rounded-full font-semibold text-sm tracking-wide">
              Ordina ora <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/prodotti?cat=Gluten Fit" data-testid="hero-glutenfit-btn" className="inline-flex items-center gap-2 px-8 py-4 rounded-full font-semibold text-sm tracking-wide border border-[#1C1917] hover:bg-[#1C1917] hover:text-[#FDFBF7] transition-colors duration-300">
              Menu Gluten Fit
            </Link>
          </motion.div>
        </div>
        <div className="lg:col-span-5 relative">
          <motion.div
            initial={{ opacity: 0, scale: 0.94 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 0.5, duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="rounded-[2rem] overflow-hidden border border-[#E7E0D8] shadow-[0_40px_80px_-40px_rgba(28,25,23,0.4)] aspect-[4/5]"
          >
            <motion.img src={HERO_IMG} alt="Piatto pronto gluten free" style={{ y: imgY }} className="w-full h-[115%] object-cover" />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.15 }}
            className="absolute -bottom-5 -left-5 bg-white border border-[#E7E0D8] rounded-2xl px-5 py-3.5 shadow-xl"
          >
            <p className="font-serif-display font-bold text-[#2E8A57] text-xl leading-none">5 min</p>
            <p className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#78716C] mt-1">dalla busta al piatto</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
